const projectHostMap = {
    dezign: process.env.REACT_APP_URL_HSEDESIGN_COM,
    geography: process.env.REACT_APP_URL_GEOGRAPHY,
  }

export const getProjectHrefPrefix = (project: any) => {
    return typeof window !== 'undefined' ? window.location.origin : process.env.REACT_APP_URL_HSEDESIGN_COM
}const projectHostMap = {
    dezign: process.env.REACT_APP_URL_HSEDESIGN_COM,
    geography: process.env.REACT_APP_URL_GEOGRAPHY,
  }

export const getProjectHrefPrefix = (project: any) => {
    return typeof window !== 'undefined' ? window.location.origin : process.env.REACT_APP_URL_HSEDESIGN_COM
}